import { blockCategories } from '../../categories';

export default (editor) => {
    editor.DomComponents.addType('sio-spacer', {
        model: {
            defaults: {
                'custom-name': 'Abstandshalter',
                tagName: 'div',
                draggable: true,
                droppable: false,
                attributes: {
                    class: 'sio-spacer',
                },
                style: {
                    // height: '40px',
                },
                traits: [
                    {
                        type: 'slider-with-input',
                        name: 'height',
                        label: false,
                        displayLabel: 'Höhe',
                        property: 'height',
                        unit: 'px',
                        min: 0,
                        max: 500,
                        step: 1,
                        // default: 40,
                    },
                ],
            },
        },
    });

    editor.BlockManager.add('sio-spacer', {
        label: 'Abstandshalter',
        category: blockCategories.basic,
        content: {
            type: 'sio-spacer',
        },
        attributes: { class: '' },
        media: `<svg viewBox="0 0 24 24">
            <path d="M3 11h18v2H3zm0-7h18v2H3zm0 14h18v2H3z"/>
        </svg>`,
    });
};
